<template>
  <div>
    <div class="container-fluid">
      <!-- ============================================================== -->
      <!-- Bread crumb and right sidebar toggle -->
      <!-- ============================================================== -->
      <div class="row page-titles">
        <div class="col-md-5 col-8 align-self-center">
          <ol class="breadcrumb">
            <li class="breadcrumb-item">
              <router-link to="/home">Home</router-link>
            </li>
            <li class="breadcrumb-item">
              <router-link to="/custom-service-code">サービス一覧</router-link>
            </li>
            <li class="breadcrumb-item active">サービス</li>
          </ol>
        </div>
      </div>
      <div class="row" v-show="errors.any()">
        <div class="col-md-12">
          <div class="alert alert-warning">
            <button type="button" class="close" data-dismiss="alert" aria-label="Close">
              <span aria-hidden="true">×</span>
            </button>
            <ul>
              <li v-for="(error,index) in errors.collect()" :key="index">
                {{ error[0] }}
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <div class="card card-outline-info">
            <div class="card-header">
              <h4 class="m-b-0 text-white">サービス</h4>
            </div>
            <div class="card-body">
              <form action="#" class="form" :disabled="!isLoaded">
                <div class="form-body">
                  <template>
                    <!-- row -->
                    <div class="row">
                      <div class="col-md-3">
                        <div class="form-group" :class="{'has-danger': errors.has('display_name') }">
                          <label class="control-label">サービス名</label>
                          <input type="text" name="display_name" class="form-control" maxlength="30"
                                 v-validate="'required|max:30'"
                                 data-vv-as="サービス名"
                                 data-vv-validate-on="none"
                                 v-model="inputs.display_name">
                        </div>
                      </div>
                    </div>
                  </template>
                </div>
                <div class="form-actions">
                  <div class="row">
                    <div class="col-md-12 text-center">
                      <router-link to="/custom-service-code">キャンセル</router-link>
                      <span class="mx-2"></span>
                      <button type="button" class="action-button btn btn-danger btn-rounded"
                              @click.prevent="remove"
                              :disabled="!isLoaded"
                              v-if="id && !inputs.builtin_flag">
                        削除する
                      </button>
                      <button type="submit" class="action-button btn btn-success btn-rounded" @click.prevent="save"
                              :disabled="!isLoaded">
                        保存する
                      </button>
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
    <loading-modal v-model="isProcessing" message="更新中..."/>
    <v-dialog/>
  </div>
</template>

<script>
import co from 'co'
import api from '../../libs/Api'
import LoadingModal from '../../components/LoadingModal'

function _convertEntity2Inputs (entity) {
  return {
    display_name: entity.display_name,
    service_code: entity.service_code
  }
}

function _convertInputs2Entity (inputs) {
  return {
    display_name: inputs.display_name,
    service_code: inputs.service_code
  }
}

export default {
  name: 'CustomServiceCodeEdit',
  data () {
    return {
      id: null,
      isLoaded: false,
      inputs: {
        display_name: '',
        service_code: ''
      }
    }
  },
  components: {
    LoadingModal
  },
  created: function () {
    this.exec(_this => {
      _this.id = _this.$route.params.id
    })
  },

  mounted: function () {
    this.exec(_this => {
      return co(function * () {
        console.info(_this.id)
        if (!_this.id) {
          return Promise.resolve(null)
        }
        const res = yield api.findCustomServiceCode(_this.id)
        return Promise.resolve(res)
      }).then((res) => {
        if (!res) {
          _this.isLoaded = true
          return
        }
        _this.inputs = _convertEntity2Inputs(res)
        _this.isLoaded = true
      })
    })
  },
  methods: {
    remove () {
      if (this.inputs.builtin_flag) return
      this.$modal.show('dialog', {
        title: '確認',
        text: `削除してもよろしいですか？`,
        clickToClose: true,
        buttons: [
          {
            title: 'キャンセル'
          },
          {
            title: 'はい',
            clickToClose: true,
            handler: () => {
              this.exec(_this => {
                return co(function * () {
                  yield api.deleteCustomServiceCode(_this.id)
                }).then(() => {
                  _this.$toasted.success('削除しました。', {
                    position: 'top-center',
                    duration: 2000
                  })
                  _this.$router.push(`/custom-service-code`)
                })
              })
            }
          }
        ]
      })
    },
    save () {
      this.exec(_this => {
        return co(function * () {
          _this.$validator.errors.clear()
          if (!(yield _this.$validator.validateAll())) {
            return Promise.resolve(false)
          }
          _this.isProcessing = true
          const params = _convertInputs2Entity(_this.inputs)
          if (_this.id) {
            return yield api.putCustomServiceCode(_this.id, params)
          } else {
            return yield api.postCustomServiceCode(params)
          }
        }).then(res => {
          if (!res) return
          _this.$toasted.success('保存しました。', {
            position: 'top-center',
            duration: 2000
          })
          _this.inputs = _convertEntity2Inputs(res)
          _this.id = res.id
        }).finally(() => {
          _this.isProcessing = false
        })
      })
    }
  }
}
</script>
<style scoped>

</style>
